export function toggle() {
	Array.from(document.querySelectorAll('.js-toggle')).forEach(elem => {
		let target = document.getElementById(elem.dataset.target);

		if (!target) {
			return;
		}

		let visible = false;
		target.style.display = 'none';

		elem.addEventListener('click', () => {
			visible = !visible;
			target.style.display = visible ? 'block' : 'none';
			elem.textContent = visible ? 'Show less' : 'Read more';
		});
	});
}
